<template>
	<div class="modal-body" v-if="place">
		<!--<div class="modal-content">-->
			<!---->
		<!--</div>&lt;!&ndash; end.modal-content &ndash;&gt;-->
		<div class="modal-map">
			<GmapMap
				:center="mapCenter"
				:zoom="17"
				:options="mapOptions"
				style="width: 100%; height: 100%;">
				<GmapMarker
					:position="mapCenter"
					:draggable="true"
					@dragend="markerDrop"
				/>
			</GmapMap>
			<search-bar></search-bar>
		</div><!-- end.modal-map -->
		<dl class="map-address">
			<dt>Check Fibre Coverage at:</dt>
			<dd><formatted-address :place="place"></formatted-address></dd>
		</dl><!-- end.map-address -->
		<div class="error-bar" v-if="error">
			<svg class="icon"><use xlink:href="#error"></use></svg>
			<p>Something went wrong. Please try again.</p>
		</div><!-- end.error-bar -->
		<div class="modal-footer">
			<button class="btn white" @click.prevent="goBack()">Go Back</button>
			<button class="btn gradient-red" @click.prevent="checkCoverage()">Check Coverage</button>
		</div><!-- end.modal-footer -->
	</div>
</template>
<script>
	import {gmapApi} from 'vue2-google-maps'
	import SearchBar from '../components/MapSearchBar'
	import GoogleService from '../services/google'
	import FormattedAddress from '../components/FormattedAddress'

	export default {
		components: {
			SearchBar,
			FormattedAddress,
		},
		computed: {
			google: gmapApi,
			place() {
				return this.$store.getters['coverage/place'];
			},
			mapCenter() {
				// return this.place.geometry.location;
				return {
					lat: this.place.geometry.location.lat(),
					lng: this.place.geometry.location.lng(),
				};
			}
		},
		watch: {
			place: function() {
				this.error = false;
			}
		},
		data() {
			return {
				error: false,
				mapOptions: {
					zoomControl: true,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: false,
					disableDefaultUi: false,
					styles: [
						{
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#f5f5f5"
								}
							]
						},
						{
							"elementType": "labels.icon",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#616161"
								}
							]
						},
						{
							"elementType": "labels.text.stroke",
							"stylers": [
								{
									"color": "#f5f5f5"
								}
							]
						},
						{
							"featureType": "administrative.land_parcel",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#bdbdbd"
								}
							]
						},
						{
							"featureType": "poi",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#eeeeee"
								}
							]
						},
						{
							"featureType": "poi",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#757575"
								}
							]
						},
						{
							"featureType": "poi.park",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#e5e5e5"
								}
							]
						},
						{
							"featureType": "poi.park",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#9e9e9e"
								}
							]
						},
						{
							"featureType": "road",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#ffffff"
								}
							]
						},
						{
							"featureType": "road.arterial",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#757575"
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#dadada"
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#616161"
								}
							]
						},
						{
							"featureType": "road.local",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#9e9e9e"
								}
							]
						},
						{
							"featureType": "transit.line",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#e5e5e5"
								}
							]
						},
						{
							"featureType": "transit.station",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#eeeeee"
								}
							]
						},
						{
							"featureType": "water",
							"elementType": "geometry",
							"stylers": [
								{
									"color": "#c9c9c9"
								}
							]
						},
						{
							"featureType": "water",
							"elementType": "labels.text.fill",
							"stylers": [
								{
									"color": "#9e9e9e"
								}
							]
						}
					]
				}
			}
		},
		methods: {
			goBack() {
				this.$parent.$emit('close');
			},
			markerDrop(event) {
				// GeoCode the position of the marker
				GoogleService.geocodeLatLng(google, {
					'location': {
						lat: event.latLng.lat(),
						lng: event.latLng.lng(),
					}
				}).then(response => {
					this.$store.commit('coverage/updatePlace', response);
				});
			},
			checkCoverage() {
				// show loading state
				this.$parent.$emit('toggle-loading', true);

				// get data from place in store
				let lat = this.place.geometry.location.lat();
				let lng = this.place.geometry.location.lng();

				let params = `?latitude=${lat.toPrecision(8)}&longitude=${lng.toPrecision(8)}&solution_types[]=composite_fibre`;

				this.$store.dispatch('coverage/getFormattedAddress', {
					place: this.place
				});

				this.$store.dispatch('coverage/checkCoverage', params)
					.then(response => {
						let fibreProviders = response.vendor_coverage_data;

						// add providers to store
						this.$store.commit('coverage/updateFibreProviders', fibreProviders);

						if(!fibreProviders.length) {
							// no fibre providers available
							// do lookup for fixed lte providers for upsell
							let fixedLteParams = `?latitude=${lat.toPrecision(8)}&longitude=${lng.toPrecision(8)}&solution_types[]=connectivity_mobile`;

							this.$store.dispatch('coverage/checkCoverage', fixedLteParams)
								.then(response => {
									let fixedWirelessProviders = response.vendor_coverage_data;
									this.$store.commit('coverage/updateFixedWirelessProviders', fixedWirelessProviders);
									this.$parent.$emit('toggle-loading', false);
									this.$router.push({name: 'no-coverage'});
								}, error => {
									this.$parent.$emit('toggle-loading', false);
									this.$router.push({name: 'no-coverage'});
								});
						} else {
							this.$parent.$emit('toggle-loading', false);
							this.$router.push({name: 'providers'});
						}

					}, error => {
						// hide loading state
						this.$parent.$emit('toggle-loading', false);

						// show error in template
						this.error = true;
					});

			},
			checkCoverageOld() {
				this.$parent.$emit('toggle-loading', true);
				this.$store.dispatch('coverage/checkCoverageOldApi', {
						place: this.place
					})
					.then(response => {

						// hide the modal loader
						this.$parent.$emit('toggle-loading', false);

						// @TODO - check if any vendors are available
						let availableProviders = [];
						response.forEach(p => {
							if(p.state === 'live' || p.state === 'building') {
								availableProviders.push({
									id: p.provider_id,
									name: p.provider,
									isPreOrder: p.state === 'building'
								})
							}
						});

						// show the no coverage form
						if(!availableProviders.length) {
							this.$router.push({name: 'no-coverage'});
							return;
						}

						// add available providers to store
						this.$store.commit('coverage/updateAvailableProviders', availableProviders);

						// redirect straight to the package selection view
						// if there is only one provider available
						if(availableProviders.length === 1) {
							// set the selected provider in the store
							this.$store.commit('coverage/setProvider', availableProviders[0]);

							// show the packages view
							this.$router.push({name: 'packages'});
						} else {
							// show the providers view
							this.$router.push({name: 'providers'});
						}

					}, error => {
						console.log(error);

						// hide the modal loader
						this.$parent.$emit('toggle-loading', false);

						// @TODO - display an error message
					});
			}
		}
	}
</script>
